import React from 'react';
import { useBenchAlerts } from './BenchAlertProvider';
import { useNavigate } from 'react-router-dom';
import { Bell } from 'lucide-react';

const BenchAlertBadge = () => {
  const { counts, isApprover } = useBenchAlerts();
  const navigate = useNavigate();

  if (!isApprover) return null;

  const total = counts.pending + counts.overdue;

  return (
    <div 
      className="bench-alert-badge" 
      onClick={() => navigate('/rmg/bench-movements')}
      style={{ position: 'relative', cursor: 'pointer', marginRight: '16px' }}
      title={`${counts.pending} pending, ${counts.overdue} overdue bench movements`}
    >
      <Bell size={20} color="#475569" />
      {total > 0 && (
        <span style={{
          position: 'absolute',
          top: '-5px',
          right: '-8px',
          background: counts.overdue > 0 ? '#ef4444' : '#3b82f6',
          color: 'white',
          borderRadius: '50%',
          padding: '2px 6px',
          fontSize: '10px',
          fontWeight: 'bold'
        }}>
          {total}
        </span>
      )}
    </div>
  );
};

export default BenchAlertBadge;
